var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckmarkRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 -8.74228e-07C4.47715 -3.91405e-07 3.91405e-07 4.47715 8.74228e-07 10C1.35705e-06 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34783 18.9464 4.80429 17.0711 2.92893C15.1957 1.05357 12.6522 -1.10609e-06 10 -8.74228e-07ZM10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM13.82 6.49C13.6256 6.29943 13.3144 6.29943 13.12 6.49L8.38 11.23L6.88 9.74C6.78927 9.64332 6.66259 9.58848 6.53 9.58848C6.39741 9.58848 6.27073 9.64332 6.18 9.74L5.65 10.27C5.55534 10.3639 5.5021 10.4917 5.5021 10.625C5.5021 10.7583 5.55534 10.8861 5.65 10.98L8 13.35C8.09073 13.4467 8.21742 13.5015 8.35 13.5015C8.48259 13.5015 8.60927 13.4467 8.7 13.35L14.32 7.73C14.4147 7.63611 14.4679 7.50832 14.4679 7.375C14.4679 7.24168 14.4147 7.11388 14.32 7.02L13.82 6.49Z",
    fill: "#C2CFE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkRound);
export default __webpack_public_path__ + "static/media/icon-checkmark-round.65aca613.svg";
export { ForwardRef as ReactComponent };